/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Button, Breadcrumb, BreadcrumbItem } from "reactstrap";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import GridView from "./GridView/GridView";
import TableView from "./TableView/TableView";
import { changeView, hideLoader, showLoader } from "../../utils/action/Action";
import { useSelector, useDispatch } from "react-redux";
import "./myroutes.scss";
import { getUserRoutes } from "../../services/myRoute.service";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import { MdGridOn } from "react-icons/md";
import { FiList } from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";
import swal from "sweetalert";
const MyRoutes = ({ isUserLoggedIn }) => {
  const [viewName, setViewname] = useState("grid");
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [route, setRoute] = useState([]);
  const [pointName, setPointName] = useState({
    id: "",
    title: "",
    cityY: "",
  });
  const [routeName, setRouteName] = useState({
    id: null,
    title: null,
  });

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const current_value = useSelector(
    (state) => state.changeViewReducer.current_view,
  );
  const userName = useSelector(
    (state) => state.userDetailReducer.userData.userName,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    current_value === "table" ? setViewname("table") : setViewname("grid");
  }, [current_value]);

  useEffect(() => {
    if (isUserLoggedIn) {
      fetchUserRoutes();
    }
  }, [currentPage, pageSize]);

  const handleClick = (view) => {
    dispatch(changeView(view));
    setViewname(view);
  };

  const createNewRoute = async () => {
    if (isUserLoggedIn) {
      setShowCreateRouteModal(true);
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Login",
        text: "You want to create a new route ?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const fetchUserRoutes = async () => {
    if (isUserLoggedIn) {
      dispatch(showLoader());
      try {
        const response = await getUserRoutes({
          userName: userName,
          pageNumber: currentPage,
          pageSize: pageSize,
        });
        console.log("22====================================");
        console.log(currentPage);
        console.log(pageSize);
        console.log("====================================");
        if (response && response?.status === 200) {
          console.log("rouuuuutes", response);
          setRoute(response?.data?.data?.data);
          // setCurrentPage(response?.data?.data?.pageNumber);
          // setPageSize(pageSize);
          setTotalCount(response?.data?.data?.totalCount);
          console.log("1====================================");
          console.log(currentPage);
          console.log(totalCount);
          console.log(pageSize);
          console.log("====================================");
        }
        dispatch(hideLoader());
      } catch (err) {
        dispatch(hideLoader());
      }
    }
  };

  return (
    <div className="main_section myroutes">
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        fetchUserRoutes={fetchUserRoutes}
        pointName={pointName}
        setPointName={setPointName}
        pointId={pointName.id}
        route={route}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        // setRouteName={setRouteName}
        // routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      {/* <SearchBar /> */}
      <Container>
        <div className="breadcrumb_section">
          <Breadcrumb className="nt-breadcrumb">
            <Link to="/" className="breadcrumb_item1">
              <GoHome className="home_icon" />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
            <BreadcrumbItem active>
              <Link to="/my-routes" className="nt-breadcrumb_item2">
                My Routes
              </Link>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
      </Container>
      <Container>
        <div className="myroutes_section">
          <Container fluid>
            <div className="myroutes_box_header">
              <h4>My Routes </h4>
            </div>
            <div className="myroutes_box">
              <div className="myroutes_block">
                <div className="create_route_btn">
                  <button onClick={createNewRoute}>
                    <FaPlus size={13} /> <span>Create a New Route</span>
                  </button>
                </div>
                <div className="button_section">
                  <div className="view_btn">
                    <Button
                      type="button"
                      name="grid"
                      className={viewName === "grid" ? "btn_grid" : "btn_table"}
                      onClick={() => handleClick("grid")}
                    >
                      <MdGridOn />
                      Grid View
                    </Button>
                    <Button
                      type="button"
                      name="table"
                      className={
                        viewName === "table" ? "btn_grid" : "btn_table"
                      }
                      onClick={() => handleClick("table")}
                    >
                      <FiList />
                      Table View
                    </Button>
                  </div>
                </div>
              </div>
              {viewName === "grid" ? (
                <GridView
                  route={route}
                  fetchUserRoutes={fetchUserRoutes}
                  pointName={pointName}
                  setPointName={setPointName}
                  totalCount={totalCount}
                  pageSize={pageSize}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  isUserLoggedIn={isUserLoggedIn}
                />
              ) : (
                <TableView
                  route={route}
                  fetchUserRoutes={fetchUserRoutes}
                  pointName={pointName}
                  setPointName={setPointName}
                  totalCount={totalCount}
                  pageSize={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  setPageSize={setPageSize}
                  isUserLoggedIn={isUserLoggedIn}
                />
              )}
            </div>
          </Container>
        </div>
      </Container>
    </div>
    // </Container>
  );
};

export default MyRoutes;
